<maced-global-header globalHeaderId="globalHeader11" [title]="title" [logoUrl]="logoUrl" [logo]="logo"
  [smallLogo]="smallLogo" [logoAltText]="logoAltText" [moreMenuTitle]="moreMenuTitle" [ariaLabels]="ariaLabels"
  [hasReversedTitle]="true" [isSingleAction]="true" [hasHamburger]="true">
  <ng-container ngProjectAs="[actions]">
    <maced-button [ngClass]="isShowMenubar ? 'c-headers__actions-close-button' : 'c-headers__actions-hamburger-button'"
      size="large" color="secondary" [buttonId]="buttonId" [type]="buttonType" [name]="buttonValue" [ariaLabel]="!isShowMenubar ? 'hamburger': 'close' "
      [label]="buttonValue" (click)="openMenu()" [ariaExpanded]="isShowMenubar" [value]="buttonValue"
      [url]="currentUrl" [queryParams]="{ hasHamburger: isShowMenubar ? 0:1, type:'singleButton'}"> </maced-button>
  </ng-container>
</maced-global-header>
<main class="c-navigation " [ngClass]="{'c-navigation--overlay':isShowCascadebar}">
  <div (click)="isShowCascadebar=false" *ngIf="isShowCascadebar && isBrowser" class="c-navigation__overlay"></div>
  <a class="c-navigation__overlay" *ngIf="isShowCascadebar && !isBrowser" [routerLink]="currentUrl"> </a>
  <maced-menubar id="Menubar" *ngIf="isShowMenubar" [menuList]="menuList" [isShowExpandCollapse]="false"
    [isMenubarExpand]="true" (closeMenubarEvent)="onCloseMenubar()" (menuEvent)="onClickMenu($event)"
    (moreMenuEvent)="onClickMoreMenu()" [hasTitleBar]="false">
  </maced-menubar>
  <div class="c-navigation__cascade" [ngClass]="{'c-navigation__cascade--without-menubar': !isShowMenubar}">
    <ng-container *ngIf="isShowCascadebar">
      <ng-container *ngFor="let cascadeMenu of cascadeMenus;let i = index">
        <maced-cascade-menubar [cascadeMenubarId]="'CascadeMenubar' + i" [cascadeMenubarLabel]="cascadeMenubarLabel"
          [cascadeMenuList]="cascadeMenu.menus" (menuEvent)="onClickCascadeMenu($event,i)"
          [backQueryParams]="getBackQueryParam(cascadeMenu)" (backEvent)="onClickCascadeBack(i)"
          (closeEvent)="onClickCascadeClose()" [hasBackButton]="true" [hasCloseButton]="false" [hasTitleBar]="hasTitleBar(i)"
          [hasBreadcrumbs]="hasBreadcrumbs()" *ngIf="cascadeMenu.isVisible">
          <ng-container ngProjectAs="[breadcrumbsPanel]">
            <maced-breadcrumbs [id]="breadcrumbsContainer" [linksData]="breadcrumbsName"
              [isLinksClickable]="isLinksClickable" [nextIconClass]="nextIconClass"
              [numberOfLinksVisible]="numberOfLinksVisible" [breadCrumbLimit]='breadCrumbLimit'>
            </maced-breadcrumbs>
          </ng-container>
        </maced-cascade-menubar>
      </ng-container>
    </ng-container>
  </div>
  <div class="c-navigation__cards" [ngClass]="{'c-navigation__cards--hide': (isShowCascadebar|| isShowMenubar)&& isMobileWidth()}">
    <div class="flex flex-wrap">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <maced-enhanced-card [id]="dummyId6" name="enhancedCard" [cardImageWidthLarge] = 215 [cardImageHeightLarge] = 125
          imageUrl="../assets/default/images/yx8h6prm3pfpcppq53wa.png" cardTitle="Card With Link"
          subtitle="Share It!, Level 5" [list]="list" targetUrl="/button" ariaLabel="dummyAriaLabel5">
        </maced-enhanced-card>
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <maced-enhanced-card [id]="dummyId7" name="enhancedCard2" [cardImageWidthLarge] = 215 [cardImageHeightLarge] = 125
          imageUrl="../assets/default/images/yx8h6prm3pfpcppq53wa.png" cardTitle="Card With Link"
          subtitle="Share It!, Level 5" [list]="list" targetUrl="/toast" ariaLabel="dummyAriaLabel6">
        </maced-enhanced-card>
      </div>
    </div>
  </div>
</main>